
































































































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import dataCenter from "@/request/requestIndex/index";
import {
  QuestionParameter,
  QuestionParameterI18n,
} from "@/pbjs/xcommon/ticket_pb";
import { setCommon, errorMsg, setPage } from "@/utils/request";
@Component({
  name: "riskReporting",
})
export default class RiskReporting extends Vue {
  @Prop() editData: any; // 编辑数据
  @Prop() title: any;
  @Provide() private repayReportForm: any = {
    textarea: "",
    paymentTime: "",
  };
  @Provide() private msg: any = this.$message;
  @Provide() private isSaved: any = false;
  @Provide() private isUpdate: any = false;
  @Provide() private id: any = this.editData.id;
  @Provide() private parameterValue: any = this.editData.qptype; // 参数类型
  @Provide() private parameterOptions: any = [
    {
      value: "1",
      label: "0类问题",
    },
    {
      value: "2",
      label: "1类问题",
    },
    {
      value: "3",
      label: "2类问题",
    },
    {
      value: "10",
      label: "选项",
    },
  ];
  @Provide() private parameterInputValue: any = this.editData.value; // 参数值
  @Provide() private status: any = this.editData.status;
  @Provide() private reasonkey: any = this.editData.reasonkey;
  @Provide() private translationOneOptions: any = [
    {
      value: "en-US",
      label: "英语",
    },
    {
      value: "es-MX",
      label: "西班牙语",
    },
    {
      value: "vi-VN",
      label: "越南语",
    },
    {
      value: "ar-AR",
      label: "阿拉伯语",
    },
  ];
  @Provide() private translationOne: any = this.editData.translationOneVal; // 第一个翻译
  @Provide() private languageOne: any = this.editData.languageOneVal; // 第一个翻译的语言
  @Provide() private translationTwoOptions: any = [
    {
      value: "en-US",
      label: "英语",
    },
    {
      value: "es-MX",
      label: "西班牙语",
    },
    {
      value: "vi-VN",
      label: "越南语",
    },
    {
      value: "ar-AR",
      label: "阿拉伯语",
    },
  ];
  @Provide() private languageTwo: any = this.editData.languageTwoVal; // 第二个翻译
  @Provide() private translationTwo: any = this.editData.translationTwoVal; // 第二个翻译的语言
  @Provide() private attributesOptions: any = [
    {
      value: "2",
      label: "失效",
    },
    {
      value: "1",
      label: "有效",
    },
    {
      value: "3",
      label: "拒贷",
    },
    {
      value: "10",
      label: "无属性",
    },
  ];
  @Provide() private attributes: any = this.editData.action; // 属性
  private mounted() {
    if (this.parameterValue == 10) {
      this.parameterOptions = [
        {
          value: "10",
          label: "选项",
        },
      ];
      this.attributesOptions = [
        {
          value: "2",
          label: "失效",
        },
        {
          value: "1",
          label: "有效",
        },
        {
          value: "3",
          label: "拒贷",
        },
      ];
    } else if (this.parameterValue == "") {
      this.parameterOptions = [
        {
          value: "1",
          label: "0类问题",
        },
        {
          value: "2",
          label: "1类问题",
        },
        {
          value: "3",
          label: "2类问题",
        },
        {
          value: "10",
          label: "选项",
        },
      ];
      this.attributesOptions = [
        {
          value: "2",
          label: "失效",
        },
        {
          value: "1",
          label: "有效",
        },
        {
          value: "3",
          label: "拒贷",
        },
        {
          value: "10",
          label: "无属性",
        },
      ];
    } else {
      this.parameterOptions = [
        {
          value: "1",
          label: "0类问题",
        },
        {
          value: "2",
          label: "1类问题",
        },
        {
          value: "3",
          label: "2类问题",
        },
      ];
      this.attributesOptions = [
        {
          value: "10",
          label: "无属性",
        },
      ];
    }
    this.translationOneOptions = this.translationOneOptions.filter(
      (item: any) => {
        return item.value != this.editData.languageTwoVal;
      }
    );
    this.translationTwoOptions = this.translationTwoOptions.filter(
      (item: any) => {
        return item.value != this.editData.languageOneVal;
      }
    );
  }
  // 点击关闭弹窗
  private hideContainer() {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
  }
  private updateList() {
    this.$emit("updateList");
  }
  // 还款问题校验
  private saveRiskReportJudgement() {
    let parameterInputValueFlag = /^\s+$/.test(this.parameterInputValue);
    let translationOneFlag = /^\s+$/.test(this.translationOne);
    if (
      this.parameterValue != "" &&
      !parameterInputValueFlag &&
      this.parameterInputValue != "" &&
      this.attributes != "" &&
      this.languageOne != "" &&
      !translationOneFlag &&
      this.translationOne != ""
    ) {
      this.isSaved = true;
      return true;
    }
    return false;
  }
  // 提交
  private async saveRiskReport() {
    let that = this;
    if (that.saveRiskReportJudgement()) {
      let transitionList: any[] = [
        {
          lang: this.languageOne,
          value: this.translationOne,
        },
        {
          lang: this.languageTwo,
          value: this.translationTwo,
        },
      ];
      let req2 = new QuestionParameter();
      req2.setId(this.id);
      req2.setQptype(this.parameterValue);
      req2.setDesc("");
      req2.setValue(this.parameterInputValue);
      req2.setAction(this.attributes);
      req2.setOpuid("");
      req2.setUtime("");
      req2.setStatus(this.status);
      req2.setReasonkey(this.reasonkey);
      let _arr: any = [];

      transitionList.forEach((item) => {
        let req3 = new QuestionParameterI18n();
        req3.setLang(item.lang);
        req3.setValue(item.value);
        _arr.push(req3);
      });
      req2.setI18nList(_arr);
      dataCenter.commonApi
        .addQuestionFn({
          setData: req2,
        })
        .then(
          (res: any) => {
            if (res.code === 0) {
              this.msg({
                type: "success",
                message: "提交成功",
              });
              this.hideContainer();
              this.updateList();
            } else {
              this.isSaved = false;
            }
          },
          (oError: any) => {
            that.isSaved = false;
          }
        );
    } else {
      this.isSaved = false;
      this.$message({
        type: "error",
        message: "带*号不能为空",
      });
    }
  }

  private hideMsk() {
    this.hideContainer();
  }
  private parameterValueChange(val: any) {
    this.attributes = "";
    if (val == 10) {
      this.attributesOptions = [
        {
          value: "2",
          label: "失效",
        },
        {
          value: "1",
          label: "有效",
        },
        {
          value: "3",
          label: "拒贷",
        },
      ];
    } else if (val == "") {
      this.attributesOptions = [
        {
          value: "2",
          label: "失效",
        },
        {
          value: "1",
          label: "有效",
        },
        {
          value: "3",
          label: "拒贷",
        },
        {
          value: "10",
          label: "无属性",
        },
      ];
    } else {
      this.attributesOptions = [
        {
          value: "10",
          label: "无属性",
        },
      ];
    }
  }
  private languageOneChange(val: any) {
    let transitionList = [
      {
        value: "en-US",
        label: "英语",
      },
      {
        value: "es-MX",
        label: "西班牙语",
      },
      {
        value: "vi-VN",
        label: "越南语",
      },
      {
        value: "ar-AR",
        label: "阿拉伯语",
      },
    ];
    this.translationTwoOptions = transitionList.filter((item: any) => {
      return item.value != val;
    });
  }
  private languageTwoChange(val: any) {
    let transitionList = [
      {
        value: "en-US",
        label: "英语",
      },
      {
        value: "es-MX",
        label: "西班牙语",
      },
      {
        value: "vi-VN",
        label: "越南语",
      },
      {
        value: "ar-AR",
        label: "阿拉伯语",
      },
    ];
    this.translationOneOptions = transitionList.filter((item: any) => {
      return item.value != val;
    });
  }
}
